import type { ConsultationWaitlistDto, WaitlistAvailability } from '@montugroup/pms-api-contracts';

// The band times must match pms-service `src/modules/consultation-waitlist/domain/waitlist-bands.ts`, which decides
// which offers a patient gets: MORNING before 12:00, AFTERNOON 12:00–16:59, EVENING 17:00 or later, in the patient's
// timezone.
export const WAITLIST_AVAILABILITY_OPTIONS: { value: WaitlistAvailability; label: string; description: string }[] = [
  { value: 'FLEXIBLE', label: 'Flexible', description: "Any time (you'll get offers sooner)" },
  { value: 'MORNING', label: 'Morning only', description: 'Before 12pm' },
  { value: 'AFTERNOON', label: 'Afternoon only', description: '12pm - 5pm' },
  { value: 'EVENING', label: 'Evening only', description: 'After 5pm' },
];

export const DEFAULT_WAITLIST_AVAILABILITY: WaitlistAvailability = 'FLEXIBLE';

export const waitlistAvailabilityLabel = (availability: WaitlistAvailability): string =>
  WAITLIST_AVAILABILITY_OPTIONS.find((option) => option.value === availability)?.label ?? availability;

// NOT_JOINED with a previous preference means the patient was on the waitlist for an earlier booking
export const isWaitlistRejoin = (waitlist: ConsultationWaitlistDto): boolean =>
  waitlist.status === 'NOT_JOINED' && waitlist.availability !== null;

// shared by the consultation card and the post-booking dialog, so the two never disagree
export const waitlistJoinMessage = (rejoin: boolean, doctorName?: string): string =>
  rejoin
    ? 'You were on the waitlist before. Rejoin for your new appointment?'
    : `Want an earlier appointment? Join the waitlist and we'll text you if an earlier time${
        doctorName ? ` with ${doctorName}` : ''
      } becomes available.`;

export const WAITLIST_NOT_ELIGIBLE_MESSAGE = 'This appointment can no longer join the waitlist.';
export const WAITLIST_CHANGE_REFUSED_MESSAGE =
  "Your preference couldn't be changed because this appointment is no longer eligible for the waitlist.";
// announced by the consultation card after each change
export const WAITLIST_JOINED_MESSAGE = "You've joined the waitlist.";
export const WAITLIST_PREFERENCE_SAVED_MESSAGE = 'Your waitlist preference has been saved.';
export const WAITLIST_LEFT_MESSAGE = "You've left the waitlist.";
export const WAITLIST_GENERIC_ERROR_MESSAGE = 'Something went wrong. Please try again.';
